import { SITE } from "@/data/site"

function Edition() {
  return (
    <section className="relative min-h-[80vh] w-full overflow-hidden md:min-h-screen">
      <img src={SITE.editionBg} alt="" className="absolute inset-y-0 left-4 right-4 h-full object-cover md:inset-0 md:w-full" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="relative z-10 flex min-h-[80vh] w-full flex-col items-center justify-center px-8 py-32 text-center md:min-h-screen md:py-28">
        <p className="font-sans-ui translate-y-[2cm] text-[11px] tracking-[0.48em] text-[#c4a574]">04</p>
        <h2 className="font-sans-ui mt-[0.5cm] translate-y-[2cm] text-xs tracking-[0.55em] text-stone-200">
          {SITE.edition}
        </h2>
        <p className="font-display mt-8 translate-y-[2cm] whitespace-nowrap text-[28px] text-[#f7f1e6] md:mt-6 md:text-7xl">{SITE.editionLabel}</p>
        <div className="mt-10 h-px w-16 translate-y-[2cm] bg-[#c4a574]/70" />
      </div>
    </section>
  )
}

export default Edition
